import React, { Component } from 'react';
import { CustomCard } from "../../../../components/Card/CustomCard";
import { Timeline, Event } from "react-timeline-scribble";

class Antecedentes extends Component {

    contenido = () => (
        <div id="antecedentes">
            <Timeline>
                <Event interval="Antecedentes">
                    <p className="fuente-monserrat" align="justify">
                        El Instituto Universitario de Diseño Las Mercedes inicia su desarrollo institucional en el marco de las Normas que venían desarrollándose en el año 1970, cuando la reforma de la Ley de Universidades autoriza la creación y funcionamiento de Institutos y Colegios Universitarios dependientes del Ministerio de Educación para ofrecer carreras cortas, especializadas en áreas del conocimiento o tipo de programas, con el fin de responder a la demanda del sector empresarial del país, interesados en la formación de recursos humanos técnicamente capacitados para incorporarlos al proceso de industrialización y democratización emprendida por el Estado Venezolano. El efecto de esta política en el sector educativo se evidenció por el alto porcentaje de ingreso de los estudiantes de la educación media, quienes hasta entonces contaban con la única salida de proseguir sus estudios en las universidades nacionales y/o internacionales.
                        <br/><br/>En la década de los ’80 se promovió la creación de instituciones de educación superior de gestión privada, la diversificación de la oferta educativa en el campo de los estudios científico-tecnológicos y una gran heterogeneidad en los niveles de calidad de las propuestas.
                        <br/><br/>En este escenario, el Instituto Universitario de Diseño Las Mercedes inicia sus actividades en septiembre de 1999, mediante el Proyecto que fuera enviado al Consejo Nacional de Universidades (CNU) para el egreso de Técnicos Superiores Universitarios en Diseño Gráfico, de Modas, Interior, Textil y Publicidad y Mercadeo (1998); elaborado especialmente para regir las exigencias de experimentalidad e innovación educativa propuestas.
                    </p>
                </Event>
            </Timeline>
        </div>  
    )

    render() { 
        return (
            <CustomCard
                content={this.contenido()}
            /> 
        );
    }
}
 
export default Antecedentes;


// WEBPACK FOOTER //
// ./src/site/Componentes/Institucion/Contenido/Antecedentes.jsx